import React, { ComponentType, PropsWithChildren } from 'react';

import { ShimmerImage, ShimmerProps, ShimmerText } from './Shimmer.styles';

interface ShimmerWrapperProps extends ShimmerProps {
  loading?: boolean;
}

const ShimmerWrapper = <T extends { Component: ComponentType<ShimmerProps> } & ShimmerWrapperProps>(
  props: PropsWithChildren<T>,
) => {
  const { loading, children, ...rest } = props;
  return loading ? <props.Component {...rest} /> : <>{children}</>;
};

export const ShimmerTextWrapper = (props: PropsWithChildren<ShimmerWrapperProps>) => {
  return <ShimmerWrapper Component={ShimmerText} {...props} />;
};

export const ShimmerImageWrapper = (props: PropsWithChildren<ShimmerWrapperProps>) => {
  return <ShimmerWrapper Component={ShimmerImage} {...props} />;
};
